import GooglePay from './GooglePay';

export const GooglePayExpress = (props) => {
    return (
        <GooglePay isExpress={true} {...props}/>
    )
}

export default GooglePayExpress;